import React, { useLayoutEffect } from "react";
import { useHistory } from "react-router-dom";
import { observer } from "mobx-react";

import { useStore } from "../../store";
import { IrregularList } from "../../components";
import { Props } from "./SearchResultHeader";
import SearchListNull from "./SearchListNull";
import { getStorage } from "../../utils/storage";

const SearchList = ({ tag }: Props) => {
  const history = useHistory();
  const {
    appStore: {
      apiHeaderState,
      appState: { languageCode },
    },
    searchStore: { searchState, onInitSearchList, onUpdateSearchList },
    detailStore: { onCopyDetailState },
  } = useStore();

  // req 변경 시 update list 갱신
  useLayoutEffect(() => {
    onUpdateSearchList(apiHeaderState, tag);
    return () => {
      onInitSearchList();
    };
    // eslint-disable-next-line
  }, [tag]);

  const onGetProjects = () => onUpdateSearchList(apiHeaderState);

  const onClickItem = (id: string) => {
    const searchType =
      getStorage("select_type") === "hashtag" ? "hashtag" : "search";
    onCopyDetailState({ ...searchState, tag, searchType });
    history.push(`/detail/${id}`);
  };

  return (
    <IrregularList
      list={searchState.list}
      languageCode={languageCode}
      nullList={<SearchListNull />}
      onGetProjects={onGetProjects}
      onClickItem={onClickItem}
      isLoading={searchState.isLoadingList}
    />
  );
};

export default observer(SearchList);
